import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  public modalRef: BsModalRef;
  forgotPasswordForm: any = FormGroup;
  error: Boolean = false;
  success: Boolean = false;
  successMessage: String="";
  errorMessage:String = "";
  public loading = false;
  config = {
    animated: true,
    keyboard: false,
    backdrop: true,
    ignoreBackdropClick: true,
    class: "forgotPwdModal"
  };

  constructor(private fb: FormBuilder, private http: AuthService, private modalService: BsModalService, private router: Router) { }

  ngOnInit() {
    //reactive form builder
    this.forgotPasswordForm = this.fb.group({
      email : ['', [Validators.email, Validators.required]]
    });
  }

  //forgot password function
  forgotPwd(userEmail, modalData){
    this.loading = true;
    var forgotObj = {
      email : encodeURIComponent(userEmail.email.trim())
    }
    this.http.forgotPwdAPi(userEmail).subscribe(
      res=>{
        this.loading = false;
        if(res['error'] === 0){
          this.modalRef = this.modalService.show(modalData, this.config);        
          this.error = false;
          this.errorMessage = "";
          this.success = true;
          this.successMessage = "Please check your email for new password";
          this.forgotPasswordForm.reset();
          // setTimeout(() => {    //<<<---    using ()=> syntax
          //   this.router.navigate(['/login']);
          // }, 3000);
            
        }else{
          this.modalRef = this.modalService.show(modalData, this.config);        
          this.success = false;
          this.error = true;
          // this.forgotPasswordForm.reset();
          this.successMessage = "";
          this.errorMessage = res.message;
        }
      },
      error=>{
        this.modalRef = this.modalService.show(modalData, this.config);        
        this.success = false;
        this.loading = false;
        this.error = true;
        // this.forgotPasswordForm.reset();
        this.successMessage = "";
        this.errorMessage = error.message;
      }
    )
  }


  //removing error messages
  clearExisitingErrors(){
    // this.success = false;
    // this.error = false;
    // this.successMessage = "";
    // this.errorMessage = "";
  }

  //redirecting to login page
  cancel(){
    this.router.navigate(['/login']);
  }

  //login
  login(){
    this.modalRef.hide();
    this.router.navigate(['/login']);
  }

  ok(){
    this.modalRef.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/forgot-password/forgot-password.component.ts